<template>
  <div v-if="this.$root.guiPerm == 'ROOT'">
    <slot
      data-bs-toggle="modal"
      :data-bs-target="'#BatchExtend' + TbtnId"
    ></slot>
    <div
      class="modal fade"
      :id="'BatchExtend' + TbtnId"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      style="background: rgba(0, 0, 0, 0.8)"
    >
      <div class="modal-dialog modal-ext modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              회원 일괄등록
            </h5>
          </div>
          <div class="modal-body">
            <p>회원 일괄등록 시스템</p>
            <i class="bi bi-info-circle"></i> 주의!주의!조심히쓰세요!!!! 아직
            대충 만든거라 잘 작동안할수도 있음 테스트할려고 만든거니 어느정도는
            감안을....<br />
            <textarea
              v-model="regRawData"
              placeholder="규격에 맞는 데이터를 엑셀에서 ctrl c ctrl v 하세요"
              class="form-control"
            ></textarea>
            <br />
            성별 데이터 없으면 남자로 처리, 레벨 없으면 GK로 처리<br />
            <input type="checkbox" v-model="addSubToo" /> 아이디까지 주문하기<br />
            <input type="checkbox" v-model="doPayToo" /> 결제완료하고 만료일까지
            설정하기<br />
            <tree-btn :tree="this.$refs.biz" />

            <div class="flex_center">
              <button
                class="btn btn-danger"
                data-bs-dismiss="modal"
                @click="doIt()"
              >
                DO IT NOW
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Tree
      :key="$route.path"
      :tree-data="this.$root.businesses"
      :selectable="['CLASS']"
      render-button
      :callback="selectedBiz"
      ref="biz"
    />
  </div>
</template>

<script>
import axios from "axios";
import Tree from "./Tree.vue";
import TreeBtn from "./treeBtn.vue";
export default {
  components: { Tree, TreeBtn },
  name: "StudentMultiple",
  props: {
    btnId: String,
  },

  data: function () {
    return {
      regRawData: "",
      addSubToo: false,
      doPayToo: false,
      selBiz: 0,
    };
  },
  methods: {
    doIt() {
      if (!confirm("ARE YOU READYYYYYYY?")) {
        alert("SYSTEM HALTED....");
        return;
      }
      this.regRawData
        .trim()
        .split("\n")
        .forEach((row) => {
          var fdata = row.split("\t");
          var data = {
            username: fdata[0],
            password: fdata[1],
            hanName: fdata[2],
            parentName: fdata[3],
            engName: fdata[4],
            gender: fdata[5],
            date_of_birth: fdata[6],
            student_phone: fdata[7],
            parent_phone: fdata[8],
            address: fdata[9],
            level: fdata[10],
            end_date: fdata[11],
            class_num: fdata[12],
            beta_score: fdata[13],
          };

          axios({
            method: "POST",
            url: "/students",
            data: {
              activeBusiness: data.class_num || "316",
              address: data.address || "1",
              birth_of_day: data.date_of_birth || "1",
              bookclub_status: "1",
              engName: data.engName || "1",
              gender: data.gender || 1,
              hanName: data.hanName || "1",
              parentName: data.parentName || "1",
              parentPhone: data.parent_phone || "1",
              password: data.password || "1",
              phone: data.student_phone || "1",
              uracle_status: "",
              username: data.username,
              vocajoa_status: "",
              beta_score: data.beta_score || 0,
              pass_allowed: false,
              recommenderid: null,
            },
          }).then((response) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message:
                    data.username +
                    " 처리할 수 없습니다 " +
                    response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              $.notify(
                {
                  // options
                  message: data.username + " 학생 생성이 처리되었습니다",
                },
                {
                  // settings
                  type: "success",
                  z_index: 9999,
                }
              );
              if (this.addSubToo) {
                $.notify(
                  {
                    // options
                    message: data.username + " 아이디 생성을 처리중입니다",
                  },
                  {
                    // settings
                    type: "info",
                    z_index: 9999,
                  }
                );

                var timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
                var now = new Date(Date.now() - timezoneOffset); // 현재 날짜 및 시간

                axios
                  .post("/subscriptions", {
                    student: response.data.id,
                    product: 56,
                    paymentMethod: "CASH",
                    hopeStart: now,
                    level: data.level || "0",
                  })
                  .then((response) => {
                    if (response.data.error) {
                      $.notify(
                        {
                          // options
                          message:
                            data.username +
                            " ID 추가 실패: " +
                            response.data.error,
                        },
                        {
                          // settings
                          type: "danger",
                          z_index: 9999,
                        }
                      );
                    } else {
                      var subId = response.headers.location.split("/")[2];
                      if (this.doPayToo) {
                        axios
                          .patch("/subscriptions/" + subId, {
                            usid: data.username,
                            state: "ACTIVE",
                            school_id: "1",
                          })
                          .then((response) => {
                            if (response.data.error) {
                              $.notify(
                                {
                                  // options
                                  message:
                                    data.username +
                                    " 처리할 수 없습니다 " +
                                    response.data.error,
                                },
                                {
                                  // settings
                                  type: "danger",
                                  z_index: 9999,
                                }
                              );
                            } else {
                              console.log(response.data.data);
                              $.notify(
                                {
                                  // options
                                  message:
                                    data.username + " 대행에 성공하였습니다.",
                                },
                                {
                                  // settings
                                  type: "success",
                                  z_index: 9999,
                                }
                              );

                              axios
                                .patch("/subscriptions/" + subId, {
                                  end_date: data.end_date,
                                })
                                .then((response) => {
                                  if (response.data.error) {
                                    $.notify(
                                      {
                                        // options
                                        message:
                                          data.username +
                                          " " +
                                          response.data.error,
                                      },
                                      {
                                        // settings
                                        type: "danger",
                                        z_index: 9999,
                                      }
                                    );
                                  } else {
                                    console.log(response.data.data);
                                    $.notify(
                                      {
                                        // options
                                        message:
                                          data.username + " 성공하였습니다.",
                                      },
                                      {
                                        // settings
                                        type: "success",
                                        z_index: 9999,
                                      }
                                    );
                                  }
                                });
                            }
                          });
                      }
                    }
                  });
              }
            }
          });
        });
    },
    selectedBiz(biz) {
      this.selBiz = biz;
    },
  },
};
</script>

<style></style>
